import { render, staticRenderFns } from "./LanguageSelectorImage.vue?vue&type=template&id=f2123ca8&scoped=true"
import script from "./LanguageSelectorImage.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorImage.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectorImage.vue?vue&type=style&index=0&id=f2123ca8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2123ca8",
  null
  
)

export default component.exports